<div *ngFor="let alert of alerts"
     class="{{cssClass(alert)}}"
     role="alert"
     aria-live="polite">
    <span [innerHTML]="alert.message"></span>
    <button type="button"
            class="btn-close"
            aria-label="Close"
            (click)="removeAlert(alert)"></button>
</div>